import React from 'react';
import { TableResource, TableColumn } from '../types';
import { TableContainer } from '../../../Components/Table/TableContainer';

interface ResourcesContentProps {
  columns: TableColumn[];
  data: TableResource[];
  onRowSelect: (selectedRows: TableResource[]) => void;
  onDelete: (resourceId: number) => void;
  onDownload: (resourceId: number) => void;
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  isShowAddNewResourceButton?: boolean;
}

export const ResourcesContent: React.FC<ResourcesContentProps> = ({
  columns,
  data,
  onRowSelect,
  totalPages,
  currentPage,
  onPageChange,
  onDelete,
  onDownload,
  isShowAddNewResourceButton,
}) => {
  return (
    <div className="content">
      <h3>Resources List</h3>
      <TableContainer
        columns={columns}
        data={data}
        onRowSelect={onRowSelect}
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={onPageChange}
        onDelete={onDelete}
        onDownload={onDownload}
        isShowAddNewResourceButton={isShowAddNewResourceButton}
        emptyMessage="No resources found"
      />
    </div>
  );
};
